import React from 'react';

import CloseIcon from '@mui/icons-material/Close';
import { Dialog, IconButton, Typography } from '@mui/material';

import type { ExerciseIsDone, ExerciseUserMark } from 'api/rest/exercises/exercises.types';

import MarkExercise from './_components/MarkExercise/MarkExercise';
import useStyles from './MarkExerciseDialog.styles';

type Props = {
  open: boolean;
  onClose: () => void;
  exerciseToMark: string;
  withNext?: boolean;
  cacheStrategy?: 'apollo' | 'rq';
  initialMark?: ExerciseUserMark | null;
  initialIsDone?: ExerciseIsDone | null;
};

const MarkExerciseDialog: React.FC<Props> = ({
  open,
  onClose,
  exerciseToMark,
  withNext,
  cacheStrategy,
  initialMark,
  initialIsDone,
}) => {
  const { classes } = useStyles();
  return (
    <Dialog
      fullWidth
      maxWidth='md'
      onClose={onClose}
      open={open}
      PaperProps={{ className: classes.paper }}
      scroll='paper'
    >
      <div className={classes.wrapper}>
        <div className={classes.titleBar}>
          <Typography className={classes.title} variant='h2'>
            Jak oceniasz to zadanie?
          </Typography>
          <IconButton aria-label='Zamknij' className={classes.closeButton} onClick={onClose} size='small'>
            <CloseIcon />
          </IconButton>
        </div>
        <MarkExercise
          cacheStrategy={cacheStrategy}
          exerciseToMark={exerciseToMark}
          initialIsDone={initialIsDone}
          initialMark={initialMark}
          withNext={!!withNext}
        />
      </div>
    </Dialog>
  );
};

export default MarkExerciseDialog;
